/*
Ilan's Website
Copyright (C) 2024-2026 ILAN ROSENBAUM

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU General Public License as published by
the Free Software Foundation, either version 3 of the License, or
(at your option) any later version.

You should have received a copy of the GNU General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import React from "react";
import SierpinskiPage from "./components/SierpinskiPage";

export { performTransitionAndRedirect } from "./utils/sierpinskiTransition";

const App: React.FC = () => {
  return <SierpinskiPage pageId="home" />;
};

export default App;
